import { useTranslate } from 'hooks/useTranslate';
import { setModal } from 'modules/_shared/redux/modalActions';
import { updateSociety } from 'modules/society/redux/societyActions';
import { useState } from 'react';
import { Modal } from 'react-bootstrap';
import { store } from 'redux/store';
import Swal from 'sweetalert2';

function ChangeBookNameModal({ actualSociety, currentBook }) {
  const { t } = useTranslate();

  const [bookName, setBookName] = useState();

  function saveBook() {
    const newBookData = actualSociety?.minutebookFolders.map((book) => {
      if (book['_id'] === currentBook['_id']) {
        return { ...book, label: bookName };
      }
      return book;
    });

    store.dispatch(
      updateSociety(
        actualSociety['_id'],
        {
          minutebookFolders: newBookData,
        },
        false
      )
    );
    store.dispatch(setModal(null));
    return Swal.fire({
      icon: 'success',
      title: `<h4 class="nk-modal-title">${t(
        'BookNameUpdatedSuccessfully'
      )}<br></h4>`,
      confirmButtonText: t('OK'),
      allowOutsideClick: false,
      showCancelButton: false,
      confirmButtonColor: '#6576FF',
    });
  }
  return (
    <>
      <Modal.Header>
        <h5>{t('UpdateBook')}</h5>
        <a className="close" onClick={() => store.dispatch(setModal(null))}>
          <em className="icon ni ni-cross" />
        </a>
      </Modal.Header>

      <Modal.Body>
        <form className="form-validate is-alter" onSubmit={saveBook}>
          <div className="form-group">
            <label className="form-label" htmlFor="full-name">
              {t('EnterNewName')}
            </label>
            <div className="form-control-wrap">
              <input
                type="text"
                className="form-control"
                value={bookName}
                onChange={(event) => setBookName(event.target.value)}
              />
            </div>
          </div>

          <button
            type="submit"
            className="btn btn-lg btn-primary"
            disabled={!bookName}
          >
            {t('Save')}
          </button>
        </form>
      </Modal.Body>
    </>
  );
}

export default ChangeBookNameModal;
